module.exports = __webpack_public_path__ + "img/service_3.2137add5.png";